export const getValue = (object = {}, key: string | string[] = '') => {
  let keys: string[]
  if (typeof key === 'string') {
    if (object[key] !== undefined) {
      return object[key]
    }
    keys = key.split('.')
  } else {
    keys = key ?? []
  }
  let result = object
  for (const k of keys) {
    result = result?.[k]
  }
  return result
}

export const isNil = (value) => value === null || value === undefined

export const setValue = (object: object, key: string | string[], value: unknown): object => {
  if (!key) return object
  let keys: string[]
  if (Array.isArray(key)) {
    keys = key
  } else if (typeof key === 'string') {
    keys = key.split('.')
  } else keys = []
  const valueToSet = keys.length === 1 ? value : setValue({ ...object[keys[0]] }, [...keys.splice(1)], value)
  return { ...object, [keys[0]]: valueToSet }
}

const isEmptyValue = (value) => isNil(value) || value === ''

export const deleteEmptyObjectValues = (obj) => {
  const cleanedObject = { ...obj }
  Object.keys(obj).forEach((key) => {
    if (isEmptyValue(obj[key])) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete cleanedObject[key]
    } else if (obj[key] instanceof Object) {
      cleanedObject[key] = deleteEmptyObjectValues(cleanedObject[key])
    }
  })
  return cleanedObject
}
